export default class PromotionClientController {
    constructor(resource) {
      this._resource = resource;
    }
  
    async getRecurrentByClientId(clientId) {
      return this._resource(`promotionClient/recurrent/${clientId}`)
        .get()
        .then(result => result)
        .catch(error => {
          throw error;
        });
    }

    async updatePromotionClient(upgradePromotion){
      return this._resource(`promotionClient/update`)
        .update(upgradePromotion)
        .then(res => { return res })
    }
  }
  